import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';

import {Router} from '@angular/router';
import {RestapiService} from '../restapi.service';


@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.css']
})
export class AddUserComponent implements OnInit {
	respPeer: any;
	peerData: any;
	respObject: any;
	email="";
	password="";
	repassword="";
	company="1";
	role="1";
  username="";
	comVisibility=true;
  constructor(@Inject(DOCUMENT) private document: Document,
        private renderer: Renderer2,private router: Router, private _rest: RestapiService) { }

  ngOnInit(): void {
  	const peerData = {}
  	this._rest.companyList(peerData).subscribe((res) => {
  		this.respPeer	=	res;
  		this.peerData	=	this.respPeer.details;
  		//console.log(JSON.stringify(this.respPeer));
  		
  	})
  }
  ValidateEmail(mail){
	if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)){
		return (true)
	} else {
		return (false)
	}
  }
  createUser(){
  	var errCounter =0
  	if(this.email==""){
  		errCounter++;
  	} else {
  		if(!this.ValidateEmail(this.email)){
  			errCounter++;
  		}
  	}
    if(this.username==""){
      errCounter++;
    }
  	if(this.password==""){
  		errCounter++;
  	}
  	if(this.repassword==""){
  		errCounter++;
  	}
  	if(this.role!="1"){
	  	if(this.company==""){
	  		errCounter++;
	  	}
	}
  	if(this.role==""){
  		errCounter++;
  	}
  	if(errCounter==0){
  		if(this.password!=this.repassword){
  			alert("Please check password fields");
  		} else {
  			const data = {
  				"email": this.email,
  				"password": this.password,
  				"company":this.company,
  				"userRole":this.role,
          "username":this.username
  			}
			this._rest.addUser(data).subscribe((res) => {
				this.respObject = res;
				if(this.respObject.error==0){
					alert("User Add Successfully.");
  					window.location.reload();
				} else {
					alert(this.respObject.errorMessage);
				}
			});
  		}
  	} else {
  		alert("All Fields are required and should be in valid format.");
  	}
  }
  changeRole(){
  	if(this.role=="1"){
  		this.comVisibility=true;
  	} else {
  		this.comVisibility=false;
  	}
  }

}
